module.exports = __webpack_public_path__ + "img/mtco.f4141d64.png";